import { FC, useEffect } from 'react';

import * as analytics from '@adsk/acs-web-analytics';

let isInvokeLoad = false; // we want it to be single instance when we move between layouts

export const AnalyticsInitializer: FC = () => {
  useEffect(() => {
    if (isInvokeLoad) {
      return;
    }
    isInvokeLoad = true;

    if (window.skipAlloyAnalyticsLoad) {
      analytics.load();
    }
  }, []);
  return null;
};

// ONLY FOR TESTSING
export const UNSAFE__resetIsInvokeLoad = () => {
  isInvokeLoad = false;
};
